import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div ``;
const Button = styled.button `
  display: inline-flex;
  align-items: center;
  background: none;
  border: 0;
  color: ${cssVar('accentColor')};
  ${fonts.gillSans.regular};
  font-size: 12px;
  letter-spacing: 0.146em;
  line-height: 18px;
  text-transform: uppercase;
  transition: color 0.15s ease-out;

  @media ${from(Device.MobileLarge)} {
    font-size: 16px;
    line-height: 22px;
  }

  &:focus,
  &:hover {
    color: ${cssVar('accentColor')};
  }
`;
const Text = styled.span ``;
const Icon = styled.span `
  color: ${cssVar('accentColor')};
  height: 18px;
  margin: 0 0 0 16px;
  transform: rotate(180deg);
  width: 18px;
`;
export default {
    Button,
    Container,
    Icon,
    Text,
};
